import React from 'react';

class RelEstoqueForm extends React.Component {

    render() {
        return(
            <div>
                <br />
                <p className={ "relestoque-txt1" }>
                    Neste relatório podemos visualizar a quantidade de baixas <br />
                    realizadas nos estoques mensalmente.
                </p>
                <br />
                <br />
                <p className={ "relestoque-txt2" }>
                    Informe o centro de custo, o produto, o ano das baixas no estoque <br />
                    e se vai verificar por Unidade de Produto ou por Unidade de Medida.
                </p><br /><br />
                <form id="relestoque-form">
                    <select value={ this.props.centro } onChange={ this.props.changeCentro }>
                        <option value="Centro">Centro</option>
                        { this.props.centros.map((item, i) =>
                            <option key={ i } value={ item.id }>{ item.nome }</option> ) }
                    </select><br />
                    <select value={ this.props.produto } onChange={ this.props.changeProduto }>
                        <option value="Produto">Produto</option>
                        { this.props.produtos.map((item, i) =>
                            <option key={ i } value={ item.id }>{ item.produto }</option> ) }
                    </select><br />
                    <select value={ this.props.ano } onChange={ this.props.changeAno }>
                        <option value="Ano">Ano</option>
                        { this.props.anos.map((item, i) =>
                            <option key={ i } value={ item }>{ item }</option> ) }
                    </select><br />
                    <select value={ this.props.verificarPor } onChange={ this.props.changeVerificarPor }>
                        <option value="">Verificar por:</option>
                        <option value="up">Unidades do Produto</option>
                        <option value="um">Unidade de Medida</option>
                    </select><br /><br />
                    <button type="button" id="relestoque-voltar-btn" onClick={ this.props.voltar }>
                        Voltar
                    </button>
                    <button type="button"
                        id="relestoque-vis-btn"
                        onClick={ this.props.visualizar }
                        disabled={ this.props.disabled }>
                        Visualizar
                    </button>
                </form>
            </div>
        );
    }

}

export default RelEstoqueForm;

